// extracted by mini-css-extract-plugin
module.exports = {"flexContainer":"Attributes__flexContainer__3oGEw","editIcon":"Attributes__editIcon__2Cir8"};